import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <Container fluid className="ogs-high-text text-center py-3 mt-5">
      <p>© 2025 Omni Group Services. All rights reserved.</p>
    </Container>
  );
}

export default Footer;